import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import { Textarea } from "@/components/ui/textarea"
import { UseFormReturn } from "react-hook-form"
import { CatalogFormData } from "../catalog-form-schema"

interface VolunteerOutputProps {
  form: UseFormReturn<CatalogFormData>
}

export function VolunteerOutput({ form }: VolunteerOutputProps) {
  return (
    <FormField
      control={form.control}
      name="volunteerOutput"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Impact Created</FormLabel>
          <FormControl>
            <Textarea
              {...field}
              placeholder="What will volunteers achieve or produce?"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}